import React from 'react';
import { ColorButton, HeadingContainer, RecordOptions, TenantsRecord } from '../../../../../neoverv/index';
import Autoload from '../../../../../neoverv/Autoload';
import GarageIcon from '../../../../../assets/images/module/general/garageIcon.svg';
import RetnalUnitIcon from '../../../../../assets/images/module/general/RentalUnitIcon.svg';
import RentalUnitIconUtilityIcon from '../../../../../assets/images/module/general/RentalUnitIconUtilityIcon.svg';
import { Group } from '@mantine/core';
var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];

export default function TenantRecordRow({
  parent,
  showAll,
  history,
  unitData,
  handleAddTenant,
  handleAddEmptyTenant,
  handleEditUnit,
  handleUnitDelete,
  TenantsAfterAddModal,
  tenantAdministration= false,
  propertySelected,
  searchValue,
  isOwnerMode
}) {
  return (
    <div className="tenant-record-row">
      <div className="row-heading-container">
        <HeadingContainer
          heading={
          <Group gap={10} wrap="nowrap">
            {unitData?.type && <img src={unitData.type === 'REGULAR' ? RetnalUnitIcon : unitData.type === 'PARKING' ? GarageIcon : RentalUnitIconUtilityIcon} width={unitData.type === 'UTILITY' ? '20px' : '16px'} />}
            {unitData.name}
            {propertySelected.propertyType === 'REGULAR' && 
            <RecordOptions
                toggleEditModal={() => handleEditUnit(unitData.id)}
                toggleDeleteModal={() => handleUnitDelete(unitData.id)}
                showDeleteButton={propertySelected.propertyType === 'REGULAR'}
                buttonStyle={{background: 'none', border: 'none'}}
              />}
          </Group>}
          rightContent={
            !tenantAdministration &&
            <div>
              <ColorButton onClick={()=>handleAddTenant()} text={isOwnerMode ? 'Eigentümer hinzufügen' : lang.tenant.text_add_tenant} />
            </div>
          }
        />
      </div>
      <div className="row-table-container">
        <TenantsRecord
          showAllTenantsAfterAdd={TenantsAfterAddModal}
          parent={parent}
          showAll={showAll}
          history={history}
          tenantAdministration={tenantAdministration}
          handleAddTenant={(startDate, endDate)=> handleAddEmptyTenant(startDate, endDate)}
          // handleTenantDelete={handleTenantDelete}
          parentId={unitData.id}
          data={unitData.tenantsData}
          editOption={true}
          labelClassName={['fullname', 'email', 'phone-number', 'move-in', 'move-out', //'tenant-portal-access'
        ]}
          labels={[
            isOwnerMode ? 'Eigentümer' : 'Mieter',//lang.general.text_full_name,
            lang.general.text_email,
            lang.general.text_phone_number,
            isOwnerMode ? 'Beginn' :lang.tenant.text_move_in,
            isOwnerMode ? 'Ende' : lang.tenant.text_move_out,
            //'Mieterportal',
            '',
          ]}
          searchValue={searchValue}
          rentalUnitData={unitData}
          isOwnerMode={isOwnerMode}
        />
      </div>
    </div>
  );
}
TenantRecordRow.defaultProps = {
  data: [],
};